import Drawer from "../../../assets/vfx/drawer/drawer";
import DisplayData from "../../common/DisplayData/DisplayData";
import { LoadingIndicator } from "../../../assets/vfx";
import { CommunityDevelopmentReplyDto } from "../../../services/dto";
import { FormatHelper } from "../../../assets/utils/helpers";

interface CommunityDevelopmentRepliesViewProps {
    data: CommunityDevelopmentReplyDto[] | undefined;
    show: boolean;
    onHide: () => void;
}

export const CommunityDevelopmentReplyView = (props: CommunityDevelopmentRepliesViewProps) => {
    return (
        <>
            <Drawer.View
                className="w-30"
                show={props.show}
                backdrop
                placement="end"
                scroll
                title="Messages"
                onHide={props.onHide}
                onDeactivate={undefined}
            >
                {!props.data ? (
                    <LoadingIndicator isFullPage />
                ) : (
                        <div>
                            <ul>
                            {
                                props.data.length > 0 ?
                                        props.data.map((item: CommunityDevelopmentReplyDto) => (
                                        <li>
                                            <div className="mb-1" style={{ fontSize: '15px', fontWeight: 400 }}>
                                                {item.message}
                                            </div>
                                            <div className="mb-2" style={{ fontSize: '12px', color: '#666' }}>
                                                {FormatHelper.formatDate(item.submittedDate)}
                                            </div>
                                        </li>

                                    )) :
                                    <DisplayData hideColon={true} importedData={"No Messages"} />
                            }
                            </ul>
                        </div>
                            
                    
                )}
            </Drawer.View>
        </>
    );

}
